import React from "react";
import styles from "./NavbarSupplier.module.css";
import logo2 from "../../assets/logo/logo2.png";
import { Link } from "react-router-dom";

const NavbarSupplier = () => {
  return (
    <nav className={styles.navbar}>
      <div className={styles.logo}>
        <Link to="/portal-comercializadores/inicio">
          <img src={logo2} alt="logo" />
        </Link>
      </div>
    </nav>
  );
};

export default NavbarSupplier;
